/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { UserContext } from '../context/userContext';
import CreateEventForm from '../components/CreateEventForm'
import { getAllVenues, getVenueById } from '../services/venue-services';
import { useCookies } from 'react-cookie';
import { deleteEventById, getEventsByVenueId } from '../services/event-services';
import SearchVenues from '../utils/SearchVenues';
import AdminEventsTable from '../components/EventTable';
import { Snackbar } from '@mui/material';
import { refreshAuthToken } from '../services/auth-services';
import SortableEventTable from '../components/SortableEventTable';



function CreateEvent() {
  const { currentUserState } = useContext(UserContext);
  const [ allVenues, setAllVenues ] = useState()
  const [ eventData, setEventData ] = useState()
  const [ loading, setLoading ] = useState(true)
  const [ displayTable, setDisplayTable] = useState()
  const [venueSearchKey, setVenueSearchKey] = useState(0)
  const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");
  const [success, setSuccess] = useState(false)
  const [ successMessage, setSuccessMessage ] = useState("")
  const [venueId, setVenueId ] = useState()
  const [eventFormKey, setEventFormKey ] = useState(0)
  const [eventTableKey, setEventTableKey] = useState(0)
  const [refreshToken, setRefreshToken] = useState()

  useEffect(() => {
    const loadVenues = async () => {
      if(currentUserState === 1)
      {
        refreshAuthToken().then(token => {
          setRefreshToken(token)
          loadAllVenues(token)
        })
      }
      else{
        refreshAuthToken().then(token => {
          setRefreshToken(token)
          loadVenueEventsById(token)
          setLoading(false)
        })
      } 
    }
    loadVenues();
  }, [ currentUserState ])

  const loadAllVenues = async (token) => {
    getAllVenues(token).then(response => {
      console.log(response)        
      var responseJson = response.data;
      var mainArray = []
      for (var i = 0; i < responseJson.length; i++) {
        var venueName = responseJson[i].venueName;
        var venueId = responseJson[i].venueId;
        var venuePostcode = responseJson[i].venuePostcode
        var object = { "label": venueName + " " + venuePostcode, "value": venueId }
        mainArray.push(object)
      }
      setAllVenues(mainArray)
      setLoading(false)
    } )
  }

  const loadVenueEventsById = (token) => {
    
    getEventsByVenueId(cookie.whatson.venueId, token).then(response => {
      setEventData(response.data)
    })
  }

  const handleVenueChange = (newValue) => {
    if(newValue !== null){
      console.log(newValue.value)
      setVenueId(newValue.value)
      getEventsByVenueId(newValue.value, refreshToken).then(response => {
        console.log(response.data)
        setEventData(response.data)
        setDisplayTable(true)
      })
    }
    else{
      setDisplayTable(false)
      setEventData()
    }
  }

  const displayVenueSearch = () => {
    console.log(currentUserState)
    console.log(loading)
    if(currentUserState === 1 && !loading){
      return(
        <SearchVenues handleVenueChange={(newValue) => handleVenueChange(newValue)} venueData={allVenues} userRole={currentUserState} keyChange={venueSearchKey}/>
      )
    }
  }

  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSuccess(false);
  };

  const handleDelete = (eventId) => {
    deleteEventById(eventId, refreshToken).then(response => {
        setSuccessMessage("Deleted event successfully")
        setSuccess(true)
        setEventTableKey(eventTableKey+1)
        var venueIdToGet = null
        if(currentUserState === 1){
          venueIdToGet = venueId
        }else{
          venueIdToGet = cookie.whatson.venueId
        }
        getEventsByVenueId(venueIdToGet, refreshToken).then(response => {
          console.log(response.data)
          console.log("got event data")
          setEventData(response.data)
        })
      }
    ).catch(() => {
      setSuccessMessage("There was an issue deleteing your event")
      setSuccess(true)
    })
  }

  const refreshForm = () => {
    setSuccessMessage("Event Added Successfully")
    setSuccess(true)
    setEventFormKey(eventFormKey+1)
    setEventTableKey(eventTableKey+1)
    var venueIdToGet = null
    if(currentUserState === 1){
      venueIdToGet = venueId
    }else{
      venueIdToGet = cookie.whatson.venueId
    }
    if(typeof(venueIdToGet) !== 'undefined'){
      getEventsByVenueId(venueIdToGet, refreshToken).then(response => {
        setEventData(response.data)
      })
    }
  }

  const displayCreateForm = () => {
    if(!loading){
      return(
        <CreateEventForm userRole={currentUserState} allVenues={allVenues} eventData={null} refreshToken={refreshToken} refreshForm={() => refreshForm()}/>
      )
    }
  }

  const displayEventsTable = () => {
    if(!loading && eventData !== undefined){
      return(
        <SortableEventTable key={eventTableKey} userRole={currentUserState} events={eventData} refreshToken={refreshToken} handleDelete={(eventId) => handleDelete(eventId)}/>
      )
    }
  }

  return (
    <Container style={{backgroundRepeat:"no-repeat",backgroundSize:"auto", minHeight:"100vh", backgroundColor:"#091440", backgroundPosition:"top", color:"white"}} fluid>
                <Snackbar
            open={success}
            autoHideDuration={5000}
            onClose={handleClose}
            message={successMessage}
          />
    <Row key={eventFormKey}>
      <Col>
        <h1 className="kanit-medium">Create Event</h1>
        {displayCreateForm()}
      </Col>
    </Row>

    <Row style={{marginTop:10, backgroundColor: "#091440", marginBottom:10}}>
        <Col>
        <h1 className="kanit-medium">Events</h1>
        <Container style={{ backgroundColor: "white", paddingTop: 50, paddingBottom: 50, borderRadius: 10 }}>
        {displayVenueSearch()}
        {displayEventsTable()}
        </Container>
        </Col>
    </Row>
  </Container>
  );
}

export default CreateEvent